import React, { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useLogoutMutation } from 'generated/graphql'
import { setAccessToken } from 'AccessToken'
import { client as LogOutClinet } from 'client'
import localForage from 'localforage'
import { SocketContext } from 'containers/Socket/SocketContext'

export const Logout = () => {
  const history = useHistory()
  const { LOGOUT }: any =
  useContext(SocketContext)
  
  const [logout, { client }] = useLogoutMutation({ client: LogOutClinet })
  useEffect(() => {
    async function userLogout() {
      try {
        await logout()
      } catch (error) {
      }

      LOGOUT()
      setAccessToken('')
      localStorage.clear()
      await localForage.clear()

      try {
        await client.resetStore()
      } catch (error) {
      }

      history.push('/login')
    }

    userLogout()
  }, [LOGOUT, client, history, logout])
  return <></>
}
